
<component :is="layout">
  <slot />
</component>
